import React, { useState } from 'react';
import { Link } from 'react-scroll';
import { useNavigate } from 'react-router-dom';
import Logo from '../logos/storage-sprint.png';

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="fixed w-full bg-white shadow-md z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img src={Logo} alt="Storage Sprint Logo" className="h-8 w-14 object-contain" />
          </div>
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-10">
            <Link
              to="home"
              smooth={true}
              className="nav-link text-gray-700 hover:text-yellow-500 font-medium cursor-pointer"
            >
              Home
            </Link>
            <Link
              to="services"
              smooth={true}
              className="nav-link text-gray-700 hover:text-yellow-500 font-medium cursor-pointer"
            >
              Services
            </Link>
            <Link
              to="about"
              smooth={true}
              className="nav-link text-gray-700 hover:text-yellow-500 font-medium cursor-pointer"
            >
              About
            </Link>
            <Link
              to="contact"
              smooth={true}
              className="nav-link text-gray-700 hover:text-yellow-500 font-medium cursor-pointer"
            >
              Contact
            </Link>
            <button
              onClick={() => navigate('/login')}
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-2 rounded-full font-medium transition duration-300 cursor-pointer"
            >
              Get Started
            </button>
          </div>
          {/* Hamburger */}
          <div className="md:hidden">
            <button
              className="text-gray-700 focus:outline-none"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
          </div>
        </div>
        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden mt-4 bg-white rounded-lg shadow-lg py-4 px-6 flex flex-col space-y-4">
            <Link
              to="home"
              smooth={true}
              onClick={() => setMenuOpen(false)}
              className="nav-link text-gray-700 hover:text-yellow-500 font-medium cursor-pointer"
            >
              Home
            </Link>
            <Link
              to="services"
              smooth={true}
              onClick={() => setMenuOpen(false)}
              className="nav-link text-gray-700 hover:text-yellow-500 font-medium cursor-pointer"
            >
              Services
            </Link>
            <Link
              to="about"
              smooth={true}
              onClick={() => setMenuOpen(false)}
              className="nav-link text-gray-700 hover:text-yellow-500 font-medium cursor-pointer"
            >
              About
            </Link>
            <Link
              to="contact"
              smooth={true}
              onClick={() => setMenuOpen(false)}
              className="nav-link text-gray-700 hover:text-yellow-500 font-medium cursor-pointer"
            >
              Contact
            </Link>
            <button
              onClick={() => {
                setMenuOpen(false);
                navigate('/login');
              }}
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-2 rounded-full font-medium transition duration-300 cursor-pointer"
            >
              Get Started
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;